<template>
  <div class="bar-box">
    <div class="bar-box-title">月度合格率</div>
    <!-- <div class="tabs">
      <span
        class="item"
        v-for="tab in tabs"
        :key="tab.value"
        :class="{ active: tab.value === activeTab }"
        @click="handleTabClick(tab.value)"
        >{{ tab.name }}</span
      >
    </div> -->
    <div id="line-chart" style="width: 100%; height: 100%"></div>
  </div>
</template>
<script setup>
import * as echarts from "echarts";
import { onMounted, ref } from "vue";
const tabs = [
  {
    name: "报告书写合格率",
    value: "request_count",
  },
  // {
  //   name: "初写报告规范",
  //   value: "report_write_count",
  // },
  // {
  //   name: "审核报告规范",
  //   value: "report_audit_count",
  // },
  {
    name: "图像质量合格率",
    value: "image_quality_count",
  },
];
const activeTab = ref("request_count");
const handleTabClick = (value) => {
  activeTab.value = value;
  setChart();
};
const generateHospitalData = () => {
  const rates = () => +(90 + Math.random() * 4).toFixed(2); // 生成 95.00-99.99 的随机比率
  // const ratesNum = () => Math.floor(Math.random() * 500) + 100; // 生成 100-1000 的随机总数

  return Array.from({ length: 50 }, (_, i) => {
    // const total = Math.floor(Math.random() * 900) + 500; // 100-1000 的随机总数

    return {
      month: i + 1,
      report_audit_count: rates(),
      image_quality_count: rates(),
    };
  });
};
const reportDataList = generateHospitalData();
const imageDataList = generateHospitalData();
onMounted(() => {
  setChart();
});
const setChart = () => {
  // 清除echarts实例
  let reportData = reportDataList.slice(0, 12);
  let imageData = imageDataList.slice(0, 12);
  console.log(reportData, imageData);
  const myChart = echarts.init(document.getElementById("line-chart"));
  myChart.setOption({
    title: {
      show: false,
    },
    legend: {
      top: "10",
      show: true,
      data: ["报告书写合格率", "图像质量合格率"],
      textStyle: {
        color: "#7ec6fc",
      },
    },
    grid: {
      left: "40",
      right: "0",
      bottom: "20",
      top: "50",
    },
    xAxis: {
      type: "category",
      data: reportData.map((item) => item.month),
      axisLabel: {
        formatter: function (value) {
          return value;
        },
        color: "#7ec6fc",
      },
    },
    yAxis: {
      type: "value",
      axisLabel: {
        formatter: function (value) {
          return value;
        },
        color: "#7ec6fc",
      },
      splitLine: {
        lineStyle: {
          color: "#2a3f66",
        },
      },
      min: 0,
      max: 100,
    },
    series: [
      {
        name: "报告书写合格率",
        data: reportData.map((item) => {
          return item.report_audit_count;
        }),
        type: "line",
        itemStyle: {
          color: "#ee6666",
        },
        // areaStyle: {
        //   color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        //     { offset: 0, color: "#ee6666" },
        //     { offset: 1, color: "#1b2a4c" },
        //   ]),
        // },
      },
      {
        name: "图像质量合格率",
        data: imageData.map((item) => {
          return item.image_quality_count;
        }),
        type: "line",
        itemStyle: {
          color: "#5470c6",
        },
        // areaStyle: {
        //   color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        //     { offset: 0, color: "#5470c6" },
        //     { offset: 1, color: "#1b2a4c" },
        //   ]),
        // },
      },
    ],
  });
};
</script>

<style scoped>
.bar-box {
  background: #1b2a4c;
  border-radius: 8px;
  color: #7ec7fd;
  padding: 16px;
  font-size: 16px;
  min-height: 120px;
  text-align: left;
  display: flex;
  flex-direction: column;
  .tabs {
    flex: 0 0 20px;
    display: flex;
    font-size: 12px;
    background-color: #2a3f66;
    border-radius: 5px;
    padding: 5px;
    margin: 10px 0;
    .item {
      text-align: center;
      cursor: pointer;
      margin-right: 10px;
      display: inline-block;
      height: 20px;
      line-height: 20px;
      border-bottom: 1px solid transparent;
    }
    .item:hover,
    .item.active {
      color: #fff;
      border-bottom: 1px solid #7ec7fd;
    }
  }
  #line-chart {
    flex: 1;
  }
}
</style>
